const topbar = {
    docs: '文档',
    help: '帮助',
    subscription: '订阅',
};
export default Object.freeze(topbar);
